import { render } from "./LineCart.vue?vue&type=template&id=62dd69a8"
import script from "./LineCart.vue?vue&type=script&lang=ts"
export * from "./LineCart.vue?vue&type=script&lang=ts"
script.render = render

export default script